import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select-method',
  templateUrl: './select-method.component.html',
  styleUrl: './select-method.component.scss',
})
export class SelectMethodComponent {
  @Input() type = '';
  @Input() quantity = 0;
  @Input() emailRegex?: RegExp;

  @Output() sendEmail = new EventEmitter<string>();
  @Output() goTo = new EventEmitter<boolean>();
  @Output() quantityChange = new EventEmitter<number>();

  isAuto = true;
  mail = '';
  isValidMail = false;

  changeQuantity(n: number) {
    this.quantity = n;
    this.quantityChange.emit(n);
  }

  nowGoTo() {
    this.goTo.emit(this.isAuto);
  }

  changeEmail(ev: CustomEvent) {
    const email = ev.detail['value'];
    if (email) this.mail = email;
    this.isValidMail = !!this.emailRegex?.test(this.mail);
  }

  confirmMail() {
    if (this.emailRegex?.test(this.mail)) {
      this.sendEmail.emit(this.mail);
    }
  }
}
